[
  {
    "url": "https://app-?\\w*.hubspot.com/contacts/\\d+/record/0-1",
    "urlForMock": "https://app-eu1.hubspot.com/contacts/25451095/record/0-1",
    "elements": [
      {
        "name": "Full Name",
        "selector": "div[data-test-id='record-highlight-main-content'] h2 > span[data-test-id='highlight-property-display-hs_full_name_or_email']"
      },
      {
        "name": "Contact Email",
        "selector": "div[data-test-id='highlight-property-item-email'] span[data-test-id='highlight-property-display-email']"
      },
      {
        "name": "Company Name",
        "selector": "div[data-test-id='highlight-property-item-jobtitle-and-company'] span[data-test-id='highlight-property-display-company']"
      },
      {
        "name": "Company Website",
        "selector": "div[data-test-id='highlight-property-item-jobtitle-and-company'] span[data-test-id='highlight-property-display-company']",
        "attributes": ["href"]
      }
    ]
  },
  {
    "url": "https://app-?\\w*.hubspot.com/contacts/\\d+/record/0-2",
    "urlForMock": "https://app-eu1.hubspot.com/contacts/25451095/record/0-2",
    "elements": [
      {
        "name": "Company Name",
        "selector": "div[data-test-id='record-highlight-main-content'] h2 span[data-test-id='highlight-property-display-name'] > span"
      },
      {
        "name": "Company Website",
        "selector": "div[data-test-id='highlight-property-item-domain'] span[data-test-id='highlight-property-display-domain'] a[target='_blank']",
        "attributes": ["href"]
      }
    ]
  },
  {
    "url": "https://app-?\\w*.hubspot.com/contacts/\\d+/record/0-3",
    "urlForMock": "https://app-eu1.hubspot.com/contacts/25451095/record/0-3",
    "elements": [
      {
        "name": "Company Name",
        "selector": "div[data-sidebar-location='CRM_RECORD_RIGHT'] div[data-test-id='company-chicklet-title'] span[data-test-id='property-input-name']"
      },
      {
        "name": "Company Website",
        "selector": "div[data-sidebar-location='CRM_RECORD_RIGHT'] a[data-test-id='company-chicklet-domain']",
        "attributes": ["href"]
      }
    ]
  }
]
